import { memo } from "react";
import { useTranslate } from "helpers";
import { VehicleListing, VehicleListingChannel } from "services/api/sales/listings/types";
import { TextArea } from "ui/components/TextField/TextArea";

interface ListingInfoCardProps {
  listing: VehicleListing;
  channel: VehicleListingChannel;
}

const ListingInfoCard: React.FC<ListingInfoCardProps> = ({ listing, channel }) => {
  const { t } = useTranslate();

  // Fallback chain (|| ne ??) jer prazne stringove tretiramo kao odsutne.
  const description = channel.effectiveDescription
    || channel.descriptionOverride
    || listing.baseDescription
    || "";

  return (
    <div className="border-b border-slate-200 pt-4 px-4">
      <div className="text-xs uppercase tracking-wide text-slate-500 font-semibold mb-3">
        {t("admin.sales.listing.detail.description")}
      </div>
      <div className="mb-4 relative">
        <TextArea
          value={description}
          readOnly
          rows={40}
          placeholder="—"
        />
        {channel.descriptionOverride && (
          <span className="text-xs text-blue-500 mt-1 inline-block">override</span>
        )}
      </div>
    </div>
  );
};

export default memo(ListingInfoCard);
